import { pinAMapPosition, MapGeographicPosition, Layer, LayerType, LayerElevationLoadStatus } from '/@/types/map'
import { generatePoint, generateLine, generatePolygon } from '/@/utils/genjson'
import { MapDoodleColor, MapElementEnum } from '/@/constants/map'
function getPinPosition (pinAMapPosition: pinAMapPosition):MapGeographicPosition {
  return { height: 0, latitude: pinAMapPosition.lat, longitude: pinAMapPosition.lng }
}

export function generatePointContent (pinAMapPosition: pinAMapPosition) {
  const position = getPinPosition(pinAMapPosition)
  return {
    type: MapElementEnum.PIN,
    content: generatePoint(position, {
      color: MapDoodleColor.PinColor,
      clampToGround: true,
    })
  }
}
function getLieOrPolyPosition (mapPosition: pinAMapPosition[]):MapGeographicPosition[] {
  const position = [] as MapGeographicPosition[]
  mapPosition.forEach(item => {
    position.push({ height: 0, latitude: item.lat, longitude: item.lng })
  })
  return position
}
export function generateLineContent (mapPosition: pinAMapPosition[]) {
  const position = getLieOrPolyPosition(mapPosition)
  return {
    type: MapElementEnum.LINE,
    content: generateLine(position, {
      color: MapDoodleColor.PolylineColor,
      directConnected: false,
    })
  }
}

export function generatePolyContent (mapPosition: pinAMapPosition[]) {
  const position = getLieOrPolyPosition(mapPosition)
  return {
    type: MapElementEnum.POLY,
    content: generatePolygon(position, {
      color: MapDoodleColor.PolygonColor,
    })
  }
}
/** 动态加载本地 JS 文件 */
export function loadOfflineScript (src:string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}
export const offlineSite = ['http://59.215.77.106:9080', 'http://192.168.0.121:9060']
// export const offlineSite = ['http://59.215.77.106:9080', 'http://192.168.0.121:9060', window.location.origin]
export function getOfflineImg (x:string, y:string, z:string) {
  return `/kfk/gmap/${z}/${x}/${y}/tile.png`
}
export function getOfflineWxImg (x:string, y:string, z:string) {
  return `/kfk/gmap/${z}/${x}/${y}/tile.png`
}
export function getOfflineBzImg (x:string, y:string, z:string) {
  return `/kfk/gmap/${z}/${x}/${y}/tile.png`
}
export function getOffline3dWxImg () {
  return '/kfk/gmap/{z}/{x}/{y}/tile.png'
}
export function getOffline3dTerrainImg () {
  return '/kfk/terrain'
}
